<div
  *ngIf="!closed"
  class="ant-alert"
  [class.ant-alert-rtl]="dir === 'rtl'"
  [class.ant-alert-success]="nzType === 'success'"
  [class.ant-alert-info]="nzType === 'info'"
  [class.ant-alert-warning]="nzType === 'warning'"
  [class.ant-alert-error]="nzType === 'error'"
  [class.ant-alert-no-icon]="!nzShowIcon"
  [class.ant-alert-banner]="nzBanner"
  [class.ant-alert-closable]="nzCloseable"
  [class.ant-alert-with-description]="!!nzDescription">
  <ng-container *ngIf="nzShowIcon">
    <ui-icon class="ant-alert-icon" [uiType]="nzIconType || inferredIconType" [uiTheme]="iconTheme"></ui-icon>
  </ng-container>
  <div class="ant-alert-content" *ngIf="nzMessage || nzDescription">
    <span class="ant-alert-message" *ngIf="nzMessage">
      <ng-container *nzStringTemplateOutlet="nzMessage">{{ nzMessage }}</ng-container>
    </span>
    <span class="ant-alert-description" *ngIf="nzDescription">
      <ng-container *nzStringTemplateOutlet="nzDescription">{{ nzDescription }}</ng-container>
    </span>
  </div>
  <button type="button" tabindex="0" *ngIf="nzCloseable || nzCloseText" class="ant-alert-close-icon" (click)="closeAlert()">
    <ng-template #closeDefaultTemplate>
      <ui-icon uiTheme="outline" uiType="close"></ui-icon>
    </ng-template>
    <ng-container *ngIf="nzCloseText; else closeDefaultTemplate">
      <ng-container *nzStringTemplateOutlet="nzCloseText">
        <span class="ant-alert-close-text">{{ nzCloseText }}</span>
      </ng-container>
    </ng-container>
  </button>
</div>
